/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { RawShaderMaterial } from './InteractiveComponents';
export const metadata = {
  demo: RawShaderMaterial,
  title: 'THREE.RawShaderMaterial'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can also write raw GLSL without any ThreeJS builtins using `}<inlineCode parentName="p">{`RawShaderMaterial`}</inlineCode>{`.`}</p>
    <p>{`This is useful if you are bringing shaders from other graphics engines and don't want to conflict with the predefined ThreeJS variables.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
